// Порогов два и они разные намеренно: ACTIVE утверждает «гонялся недавно»,
// приглушение карточки — «похоже, заброшен». Между ними оставлена нейтральная
// зона 7–14 дней, где проект уже не активен, но ещё не объявляется мёртвым.
export const ACTIVE_WINDOW_DAYS = 7;
export const STALE_AFTER_DAYS = 14;

const SECONDS_IN_DAY = 86400;

// Проект «прогонялся», если у него есть отчёт с непустым набором тестов.
// Проекты без прогонов не идут ни в суммы, ни в знаменатели: иначе ноль
// читался бы как «всё упало».
export const hasRun = (item) => Boolean(item) && typeof item.total === "number" && item.total > 0;

export const projectPassRate = (item) => {
  if (!hasRun(item)) {
    return null;
  }
  // skipped исключён из знаменателя: пропущенный тест не проходил и не падал,
  // считать его промахом значит наказывать за честные @skip. unknown остаётся —
  // неопределённый результат это не успех.
  const denominator = item.total - (item.skipped || 0);
  if (denominator <= 0) {
    return null;
  }
  return ((item.passed || 0) / denominator) * 100;
};

// Бинарно, без порога: один упавший тест делает проект красным, как один
// упавший тест делает красным билд в CI. broken включён — развалившийся от
// инфраструктуры прогон обязан считаться проблемным, иначе выглядел бы
// здоровым. Порог прячет единственное, но критическое падение и требует
// настройки под каждую команду.
export const hasFailures = (item) => hasRun(item) && (item.failed || 0) + (item.broken || 0) > 0;

export const aggregateStatistics = (statistics, nowSeconds) => {
  const items = statistics || [];
  const ran = items.filter(hasRun);
  return {
    projects: items.length,
    tests: ran.reduce((sum, item) => sum + item.total, 0),
    active: ran.filter(
      (item) => nowSeconds - item.generated_at <= ACTIVE_WINDOW_DAYS * SECONDS_IN_DAY
    ).length,
    attention: ran.filter(hasFailures).length,
  };
};
